import { NativeAudio } from "@ionic-native/native-audio";
import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperShoppingBagPage } from "./../shopper-shopping-bag/shopper-shopping-bag";
import { ShopperBuyProductPlazalistPage } from "./../shopper-buy-product-plazalist/shopper-buy-product-plazalist";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-buy-product-pay-scan_confirm",
  templateUrl: "shopper-buy-product-pay-scan_confirm.html",
})
export class ShopperBuyProductPayScanConfirmPage {
  data: any;
  bags: any = [{ name: "", unit: "", hp: "", price: "" }];
  themes: any = [{ name: "", unit: "", hp: "", price: "" }];
  // bgImage = '';
  result: any;
  shops: any = [];
  total_hp = 0;
  total_spending = 0;
  status_respone = false;
  total_selling_price = 0;
  theme = 1;
  code = "";
  plaza_id: "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private nativeAudio: NativeAudio,
    private alertCtrl: AlertController
  ) {
    this.data = this.navParams.data.data;
    this.result = this.navParams.data.result;
    this.code = this.navParams.data.code;
    this.plaza_id = this.navParams.data.plaza_id;

    this.nativeAudio.preloadSimple("uniqueId2", "assets/sounds/cash.aac");

    // for (let i = 0; i < this.data.items.length; i++) {
    //   this.shops.push({ shop_id: this.data.items[i], qty: 1 });
    // }

    // this.bgImage = 'assets/bg/shop/'+this.data.shop_id+'.jpg';
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // const loader = this.loadingCtrl.create({
    //   content: "Loading...",
    // });
    // loader.present();

    // this.storage.get("token").then((token) => {
    //   var body = JSON.stringify({
    //     merchant_id: this.data.merchant_id,
    //     discount: this.result,
    //     items: this.shops,
    //   });

    //   var link =
    //     this.services.URLShopperShop +
    //     this.data.plaza_id +
    //     "/shops?confirmFlag=false";

    //   var headers = new Headers();
    //   headers.append("Content-Type", "application/json");
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .post(link, body, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.bags = data.bag.shops;
    //         this.themes = data.bag.themes;
    //         this.total_hp = data.total_hp;
    //         this.total_spending = data.total_spending;
    //         this.total_selling_price = data.total_selling_price;
    //         loader.dismiss();
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           // this.services.presentToast(value);
    //           this.presentAlert("Alert", value);
    //         });
    //       }
    //     );
    // });
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ["OK"],
    });
    alert.present();
  }

  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperBuyShopConfirm; // change link
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });
      this.http
        .post(link, this.code, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.status_respone = data ? true : false;
            loader.dismiss();
            this.nativeAudio.play("uniqueId2");
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });

    // this.storage.get("token").then((token) => {
    //   var body = JSON.stringify({
    //     merchant_id: this.data.merchant_id,
    //     discount: this.result,
    //     items: this.shops,
    //   });

    //   var link =
    //     this.services.URLShopperShop +
    //     this.data.plaza_id +
    //     "/shops?confirmFlag=true";
    //   var headers = new Headers();
    //   headers.append("Content-Type", "application/json");
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .post(link, body, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.status_respone = true;
    //         this.bags = data.bag.shops;
    //         this.themes = data.bag.themes;
    //         this.total_hp = data.total_hp;
    //         this.total_spending = data.total_spending;
    //         loader.dismiss();
    //         this.nativeAudio.play("uniqueId2");
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  shopping() {
    this.navCtrl.push(ShopperBuyProductPlazalistPage);
  }
  bag() {
    this.navCtrl.push(ShopperShoppingBagPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm.ts